import { Observable } from "rxjs";
import { ProductActivity } from "../domain/models";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export abstract class ProductActivityRepository {
  abstract getActivitiesByProduct(productId: string): Observable<ProductActivity[]>;
}
